import React, { Component } from 'react';
import { Button, TextField } from '@material-ui/core';
import auth from '../../auth.js'
import Logo from '../../images/logo.jpg'
import './LoginPage.scss'

const INITIAL_STATE = {
  username: '',
  password: '',
  mess: "Don't be a stranger",
}

class loginDiv extends Component {
  /**
   * Initializers 
   */

  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  };
  /**
   * Handlers 
   */

  _handleLogin = async e => {
    e.preventDefault();
    try {
      const user = await auth.auth().signInWithEmailAndPassword(this.state.username, this.state.password);
      console.log(user);
      this.props.handleLogin(true);
    } catch(err) {
      if (
        err.code === 'auth/invalid-email' || 
        err.code === 'auth/wrong-password' || 
        err.code === 'auth/too-many-requests'
      ) {
        this._handleInvalid();
      } else if (err.code === 'auth/network-request-failed') {
        this._handleNoNetwork();
      } else {
        console.error(err)
      }
    }
  };

  _handleChange = field => event =>
    this.setState({
      [field]: event.target.value,
    });

  _handleInvalid = () => {
    this.setState({
      mess: this.state.mess[0] === 'N'
        ? this.state.mess.concat('!')
        : 'NO'
    });
  };

  _handleNoNetwork = () => 
    this.setState({ mess: 'Please check your internet connection.' });

  /**
   * Renderer
   */

  render() {
    return (
      <div className="Login" >
        <div className='Login-Name'> A U X E T I C </div>
        <img className='Login-Logo' src={Logo} alt="Auxetic" /> <br />
        <div className='Login-Message'> {this.state.mess} </div>
        <form className='Login-Form' onSubmit={this._handleLogin}>
          <TextField className='Login-Field' onChange={this._handleChange('username')} fullWidth autoFocus />
          <TextField className='Login-Field' onChange={this._handleChange('password')} fullWidth type="password" />
          <Button className='Login-Button' variant="contained" fullWidth color="primary" type="submit"> Login </Button>
        </form>
      </div>
    );
  }
}

export default loginDiv